import { NearbyShowsTicketType } from "./types";

export const ticketTypes: NearbyShowsTicketType[] = [
  {
    id: "1",
    name: "General Admission",
    shortName: "GA",
    price: 30.0,
  },
  {
    id: "2",
    name: "VIP",
    shortName: "VIP",
    price: 50.0,
  },
];

export const feePercentage = 0.02; // 2%
export const taxPercentage = 0.05; // 5%
export const cardSurchargePercentage = 0.0294; // 2.94%

export const steps = [
  { label: "Tickets" },
  { label: "Payment & Billing" },
  { label: "Confirmation" },
];

export const LOCALE = "en-US";
